import type { NoiseSuppressionModelDetails } from "./runtime";

export const NOISE_SUPPRESSION_AUDIO_WORKLET_PROCESSOR_NAME =
  "workadventure-noise-suppression";

export type LiteRtWasmVariant = "relaxed" | "compat";

export interface NoiseSuppressionAudioWorkletProcessorOptions {
  threads: boolean;
  numThreads: number;
  bypassUntilReady: boolean;
  liteRtVariant: LiteRtWasmVariant;
  liteRtWasmBinary: ArrayBuffer;
}

export interface NoiseSuppressionAudioWorkletReadyMessage {
  type: "ready";
  modelDetails: NoiseSuppressionModelDetails;
}

export interface NoiseSuppressionAudioWorkletErrorMessage {
  type: "error";
  message: string;
  stack?: string;
}

export interface NoiseSuppressionAudioWorkletProcessingStartedMessage {
  type: "processing-started";
  processedQuanta: number;
}

export interface NoiseSuppressionAudioWorkletBenchmarkOptions {
  warmupIterations?: number;
  benchmarkIterations?: number;
}

export interface NoiseSuppressionAudioWorkletBenchmarkSummary {
  count: number;
  totalMs: number;
  meanMs: number;
  p95Ms: number;
  minMs: number;
  maxMs: number;
}

export interface NoiseSuppressionAudioWorkletBenchmarkStartMessage {
  type: "start-benchmark";
  warmupIterations: number;
  benchmarkIterations: number;
}

export interface NoiseSuppressionAudioWorkletBenchmarkCompleteMessage {
  type: "benchmark-complete";
  frameSamples: number;
  renderQuantumSamples: number;
  summary: NoiseSuppressionAudioWorkletBenchmarkSummary;
}

export interface NoiseSuppressionAudioWorkletDisposeMessage {
  type: "dispose";
}

export type NoiseSuppressionAudioWorkletInboundMessage =
  | NoiseSuppressionAudioWorkletDisposeMessage
  | NoiseSuppressionAudioWorkletBenchmarkStartMessage;

export type NoiseSuppressionAudioWorkletOutboundMessage =
  | NoiseSuppressionAudioWorkletReadyMessage
  | NoiseSuppressionAudioWorkletErrorMessage
  | NoiseSuppressionAudioWorkletProcessingStartedMessage
  | NoiseSuppressionAudioWorkletBenchmarkCompleteMessage;
